/*
 * Module lấy dữ liệu bảng lịch sửa chữa, bảo dưỡng
 */
import api from "@/apis/ScheduleAPI";
import Crud from "./crud-base";
var crud = new Crud("Schedule", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "ScheduleID",
      name: "Description",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
